<div id="expirations" [class.loading]="loading">
  <h2 *ngIf="content.title" #header>{{ content.title }}</h2>
  <div
    *ngIf="content.description"
    [internalInnerHtml]="content.description"
    [userEventSource]="userEventSource"
    class="expirations__description"
  ></div>
  <ng-container *ngIf="loading || expirations.length; else noExpirations">
    <air-table [loading]="loading">
      <air-table-heading>{{ "general.label.expiry_date" | translate }}</air-table-heading>
      <air-table-heading>{{ "general.label.air_miles" | translate }}</air-table-heading>
      <ng-container air-table-body>
        <tr
          *ngFor="
            let expiration of expirations
              | paginate: { id: 'pagination--expirations', itemsPerPage: content.numberOfExpirations, currentPage: page }
          "
        >
          <td>{{ expiration.date | date: "dd-MM-yyyy" }}</td>
          <td>
            <div class="sticker sticker--miles sticker--red sticker--sm">
              <span class="sticker__counter">{{ expiration.points | formatNumber }}</span>
              <span class="sticker__label">{{ "general.label.air_miles" | translate }}</span>
            </div>
          </td>
        </tr>
      </ng-container>
    </air-table>
    <pagination-controls
      *ngIf="expirations.length > content.numberOfExpirations"
      id="pagination--expirations"
      class="pagination"
      [directionLinks]="false"
      [autoHide]="true"
      (pageChange)="onPageChange($event)"
    ></pagination-controls>
  </ng-container>
</div>
<ng-template #noExpirations>
  <p>{{ "dashboard.label.no_airmiles_expiring" | translate }}</p>
</ng-template>
